module.exports = __webpack_public_path__ + "static/media/handcuffs.a1bb03e8.svg";